import { ChangeDetectionStrategy, Component, Input, HostBinding } from '@angular/core';
import { ICanDisable } from '../../../base/common-behaviors/disabled';
import { ICanSize, TSize } from '../../../base/common-behaviors/size';
import { TButtonType, TButtonColor, TButtonHtmlType } from '../../interface';
import { TSkyUiSpinnerColor, TSkyUiSpinnerSize } from '../../../spinner/interface';

const DEFAULT_TYPE: TButtonType = 'primary';
const DEFAULT_COLOR: TButtonColor = 'brand';
const DEFAULT_SIZE: TSize = 'm';

@Component({
  selector: 'sky-ui-button',
  templateUrl: 'button.html',
  styleUrls: ['./button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkyUiButtonComponent implements ICanDisable, ICanSize {
  @Input() type: TButtonType = DEFAULT_TYPE;
  @Input() size: TSize = DEFAULT_SIZE;
  @Input() color: TButtonColor = DEFAULT_COLOR;
  @Input() spinnerColor: TSkyUiSpinnerColor;
  @Input() disabled = false;
  @Input() chosen = false;
  @Input() spinner = false;
  @Input() multiline = false;
  @Input() round = false;
  @Input() htmlType?: TButtonHtmlType;
  // TODO: fix styles and get rid of
  @HostBinding('style.width')
  @Input()
  width?: string;

  checkPropagation(event: MouseEvent): void {
    if (this.disabled || this.spinner) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  getSpinnerColor(): TSkyUiSpinnerColor {
    if (this.spinnerColor) {
      return this.spinnerColor;
    }

    const isBaseButtonColor = this.color === 'base';

    if ((this.type === 'primary' && !isBaseButtonColor) || this.type === 'ghost') {
      return 'inversed';
    } else if (this.type === 'secondary' || isBaseButtonColor) {
      return 'secondary';
    }

    return 'primary';
  }

  getSpinnerSize(): TSkyUiSpinnerSize {
    if (['l', 'xl'].includes(this.size)) {
      return 'm';
    }

    return 's';
  }
}
